"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var colorShades_1 = __importDefault(require("./utils/colorShades"));
var theme_json_1 = __importDefault(require("./generated/theme.json"));
var Constants_1 = require("./Constants");
var PRIMARY_COLOR = 'info';
var DEFAULT_RADIUS = 0;
var Sawmill = function (_a) {
    var colorScheme = _a.colorScheme, customColors = _a.customColors;
    return ({
        defaultRadius: DEFAULT_RADIUS,
        breakpoints: theme_json_1.default.breakpoints,
        colors: (0, colorShades_1.default)(colorScheme, customColors === null || customColors === void 0 ? void 0 : customColors.variant),
        colorScheme: colorScheme,
        fontFamily: theme_json_1.default.fontFamily,
        fontFamilyMonospace: theme_json_1.default.fontFamilyMonospace,
        fontSizes: theme_json_1.default.fontSizes,
        headings: theme_json_1.default.headings,
        other: {
            customColors: customColors,
        },
        primaryColor: PRIMARY_COLOR,
        primaryShade: Constants_1.PRIMARY_SHADES,
        spacing: theme_json_1.default.spacing,
    });
};
exports.default = Sawmill;
